export const SKIP_DEACTIVATE = new Set([
	"tagged",
	"entity",
	"add-entity",
	"new-entity",
	"search-bar",
	"search",
	"search-close-button",
	"meta-item",
	"meta-item-input",
	"input-dropdown",
	"dropdown-field",
	"dropdown-item",
	"metadata",
	"referent-mention",
	"slider",
]);

export const HOTKEYS = {
	createReferent: (e: KeyboardEvent) =>
		(e.metaKey || e.ctrlKey) && e.key === "Enter",
};

export const expandSVG = (
	<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
		<line
			x1="10"
			y1="60"
			x2="10"
			y2="90"
			stroke="white"
			stroke-width="10"></line>
		<line
			x1="5"
			y1="90"
			x2="40"
			y2="90"
			stroke="white"
			stroke-width="10"></line>
		<line
			x1="60"
			y1="10"
			x2="95"
			y2="10"
			stroke="white"
			stroke-width="10"></line>
		<line
			x1="90"
			y1="10"
			x2="90"
			y2="40"
			stroke="white"
			stroke-width="10"></line>
		<line
			x1="43"
			y1="57"
			x2="10"
			y2="90"
			stroke="white"
			stroke-width="10"></line>
		<line
			x1="57"
			y1="43"
			x2="90"
			y2="10"
			stroke="white"
			stroke-width="10"></line>
	</svg>
);

export const crossSVG = (
	<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
		<line
			x1="29"
			y1="29"
			x2="71"
			y2="71"
			stroke="black"
			stroke-width="10"></line>
		<line
			x1="29"
			y1="71"
			x2="71"
			y2="29"
			stroke="black"
			stroke-width="10"></line>
	</svg>
);

export const arrowSVG = (
	<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
		<line
			x1="42"
			y1="28"
			x2="69"
			y2="52"
			stroke="black"
			stroke-width="10"></line>
		<line
			x1="42"
			y1="72"
			x2="69"
			y2="48"
			stroke="black"
			stroke-width="10"></line>
	</svg>
);

export const logoSVG = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="50"
		height="50"
		viewBox="0 0 1080 1080">
		<rect width="100%" height="100%" fill="transparent"></rect>
		<rect
			width="1080"
			height="1080"
			x="-540"
			y="-540"
			fill="#FFF"
			rx="0"
			ry="0"
			transform="translate(540 540)"
			vectorEffect="non-scaling-stroke"
			visibility="hidden"></rect>
		<path
			fill="#162B43"
			fillOpacity="0"
			strokeWidth="0"
			d="M.002 16300V6232.9H10067.1V16300H.002"
			transform="matrix(.26 0 0 -.26 540 540) translate(-5033.55 -11266.45)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M8171.25 13396.3V13886.9l-465.17 202-49.82 21.6v526.1l-413.32 200.5v645.8l-683.73 297-683.69-297v-645.8l-413.32-200.5v-526.1l-49.83-21.6-465.16-202V13396.3c-165.83 279.3-261.12 605.2-261.12 953 0 1032.9 840.27 1873.2 1873.12 1873.2 1032.86 0 1873.13-840.3 1873.13-1873.2 0-347.8-95.29-673.7-261.09-953zm-79.21 41.7v-11.6l-435.78 189.3v408.6l49.82-21.7 385.96-167.7zm-435.78-606.1v697.5l435.78-189.2v-66.3c-119.74-170.3-267.28-319.8-435.78-442zm-1057.47 2362.4v482.1l511.63-222.3zm-79.16 0l-511.61 259.8 511.61 222.3zm-1493.24-1767.9v408.5l385.98 167.7 49.83 21.7v-408.6zm0-152.5v66.3l435.81 189.2v-697.5c-168.55 122.2-316.05 271.7-435.81 442zm3330.23 1834.7c-98.32 232.3-238.95 440.9-418.06 620-179.17 179.2-387.74 319.8-620.1 418.1-240.46 101.7-495.88 153.3-759.25 153.3-263.33 0-518.8-51.6-759.27-153.3-232.32-98.3-440.9-238.9-620.07-418.1-179.12-179.1-319.76-387.7-418.04-620-101.71-240.5-153.26-495.9-153.26-759.3 0-263.3 51.55-518.7 153.26-759.2 98.28-232.3 238.92-441 418.04-620.1 87.32-87.3 181.66-165.5 282.33-234 25.91-17.8 52.32-34.8 79.12-51.2v879l334.2 145.2 79.18 34.4 338.47 147.1V12495c-116.61 16.7-229.78 44-338.47 81.2v1114.4l-79.18-34.4V12521.9c26.25-9.9 52.6-19.2 79.18-27.8 110.35-36 223.36-61.9 338.47-77.6 26.3-3.5 52.65-6.5 79.12-9v1517.3l.28.1v86.3l-.28-.1v408.6l186.92 81.1 186.92-81.1v-354.2l79.15-34.4v866.7l-79.15 40v-431.9l-186.92 81.2-186.92-81.2v431.9l-79.12-40v-921l-338.47-147.1v408.5l33.22 14.4 16.61 7.3 245.51 106.6v86.3l-245.51-106.6-16.61-7.3-33.22-14.4-79.18-34.4-33.22-14.4-16.61-7.2-234.54-101.9v-86.3l234.54 101.9 16.61 7.1 33.22 14.5v-408.5l-334.2-145.2v936.9l334.2 162.1v-404.6l79.18 34.3v1013.7l517.14-262.7-157.02-79.7v-.1l-38.09-18.4-278.9-135.3v-87.9l257.24 124.7 38.1 18.5 79.12 40.1 185.98 94.2h.06l.88-.5.89.5h.06l185.97-94.2 79.15-40.1 38.09-18.5 257.2-124.7v87.9l-278.88 135.3-38.09 18.4v.1l-157.04 79.7 517.17 262.7v-1013.7l79.21-34.3v404.6l334.17-162.1v-936.9l-334.17 145.2v408.5l33.21-14.5 16.61-7.1 234.53-101.9v86.3l-234.53 101.9-16.61 7.2-33.21 14.4-79.21 34.4-33.21 14.4-16.61 7.3-245.54 106.6v-86.3l245.54-106.6 16.61-7.3 33.21-14.4v-408.5l-288.63 125.4-49.82 21.7-79.15 34.3-.26.1-43.16 18.8-143.5 62.3-143.46-62.3v-86.3l143.46 62.3 143.5-62.3 43.16-18.8.26-.1v-1517.3c26.5 2.5 52.86 5.5 79.15 9 115.12 15.7 228.07 41.6 338.45 77.6 26.56 8.6 52.92 17.9 79.21 27.8V13656.2l-79.21 34.4v-1114.4c-108.67-37.2-221.88-64.5-338.45-81.2v1395.5l49.82-21.7 288.63-125.4 79.21-34.4 334.17-145.2v-879c26.82 16.4 53.18 33.4 79.15 51.2 100.62 68.5 194.99 146.7 282.3 234 179.11 179.1 319.74 387.8 418.06 620.1 101.68 240.5 153.22 495.9 153.22 759.2 0 263.4-51.54 518.8-153.22 759.3"
			transform="matrix(.2 0 0 -.2 536.05 613.24) translate(-6559.2 -14353.75)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M4718.25 16126.5c5.9-18 9.96-36.5 12.21-55.6 2.25-19.2 2.04-39.2-.66-60.1s-8.14-43.2-16.34-66.8c-12.9-37.1-31.54-68.9-55.89-95.5-24.37-26.6-52.2-47.3-83.51-62-31.3-14.7-65.1-23.1-101.4-25-36.3-2-72.73 3.4-109.33 16.1-36.1 12.6-67.82 30.8-95.15 54.6-27.34 23.8-48.9 51.4-64.7 82.8-15.79 31.4-25.01 65.4-27.68 101.9-2.67 36.6 2.69 74.1 16.1 112.6 8.04 23.1 17.29 43.5 27.76 61.2 10.46 17.7 21.95 33.2 34.46 46.7 12.51 13.5 25.92 25.2 40.24 35.4 14.32 10.1 29.34 19.2 45.08 27.2l45.87-79.9c-25.81-13.7-48.43-29.9-67.86-48.5s-34.15-42.3-44.2-71.2c-8.38-24.1-11.43-48-9.16-71.7 2.27-23.7 8.87-45.9 19.8-66.4 10.94-20.5 25.82-38.6 44.63-54.4 18.82-15.7 40.75-27.9 65.78-36.6 25.03-8.7 49.92-12.8 74.68-12.2 24.75.5 47.91 5.4 69.46 14.7 21.56 9.2 40.59 22.4 57.1 39.6 16.51 17.2 28.94 37.8 37.32 61.9 10.72 30.8 14.04 59.3 9.94 85.6-4.08 26.2-12.47 53.7-25.16 82.4l77.62 37c9.45-17.9 17.1-35.8 22.99-53.8"
			transform="matrix(.19 0 0 -.19 63.24 442.33) translate(-4453.57 -16030.55)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M4680.51 16198.4c-22.76 6.9-45.41 9.3-67.94 7.4-22.52-2-44.22-8.5-65.09-19.5-20.86-11-39.08-26.5-54.63-46.5-15.55-20.1-26.07-41.4-31.56-64-5.49-22.6-6.42-44.9-2.77-66.8 3.64-22 11.61-43.2 23.92-63.5 12.31-20.4 28.29-38.2 47.95-53.4 19.66-15.3 40.88-26.3 63.65-33.2 22.77-6.9 45.42-9.3 67.95-7.3 22.52 2 44.22 8.4 65.08 19.4 20.88 11 39.08 26.5 54.63 46.6 15.55 20 26.07 41.3 31.56 63.9 5.49 22.6 6.43 44.9 2.77 66.9-3.64 21.9-11.61 43.1-23.91 63.5-12.31 20.3-28.29 38.1-47.95 53.4-19.66 15.2-40.87 26.3-63.66 33.1zm189.21-36.1c17.37-30.1 28.26-62 32.69-95.7 4.42-33.7 2.21-67.8-6.65-102.3s-25.39-67.4-49.62-98.6c-24.22-31.2-51.85-55.5-82.86-72.8-31.03-17.3-63.15-27.9-96.4-31.7-33.24-3.9-66.63-1.1-100.14 8.2-33.51 9.3-64.53 25.1-93.06 47.2-28.52 22.1-51.47 48.3-68.84 78.4-17.36 30.2-28.27 62.1-32.69 95.8-4.44 33.6-2.21 67.7 6.64 102.2s25.4 67.4 49.62 98.6c24.23 31.3 51.84 55.5 82.87 72.8 31.02 17.3 63.16 27.9 96.4 31.8 33.25 3.8 66.62 1.1 100.13-8.3 33.52-9.3 64.55-25 93.07-47.2 28.53-22.1 51.47-48.2 68.84-78.4"
			transform="matrix(.2 0 0 -.2 138.3 305.06) translate(-4637.28 -16028.68)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M5036.67 16253.3l72.15 46.7 267.77-414-60.8-39.3-418.29 147.2 190.5-294.5-72.16-46.7-267.75 414 67.27 43.5 406.45-143.1-185.14 286.2"
			transform="matrix(.21 0 0 -.21 263.12 190.48) translate(-5062.34 -15976.35)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M5755.33 16279.7l81.97 20.3 116.73-470.4-69.07-17.1-341.88 270.4 83.05-334.6-81.98-20.4-116.73 470.4 76.45 18.9 332.17-262.8-80.71 325.3"
			transform="matrix(.21 0 0 -.21 414.5 124.89) translate(-5690.73 -16013.95)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M6635.02 16099.1c-6.03 21.6-15.58 40.9-28.59 57.8-12.94 17-29.15 31-48.45 42-19.35 11.1-40.97 17.8-64.78 20-23.88 2.2-46.18-.2-66.98-7.3-20.8-7.1-39.02-17.6-54.67-31.7-15.71-14-28.53-31.1-38.46-51.2-9.99-20.1-16.08-41.9-18.28-65.3-2.2-23.4-.25-45.9 5.84-67.5 6.04-21.7 15.59-40.9 28.59-57.9 13.01-16.9 29.16-30.9 48.45-42 19.35-11.1 40.97-17.7 64.78-20 23.88-2.2 46.19.2 66.99 7.3 20.79 7.1 39.02 17.6 54.72 31.7 15.65 14 28.47 31.1 38.46 51.2 9.93 20.1 16.03 41.9 18.22 65.3 2.2 23.4.26 45.9-5.84 67.6zm67.17-169.1c-15.2-29.1-35.12-54-59.75-74.6-24.57-20.6-52.91-36.1-84.9-46.6-31.98-10.4-66.54-13.9-103.68-10.4-37.19 3.5-70.5 13.2-100.03 29.2-29.53 15.9-54.23 36.1-74.15 60.7-19.93 24.5-34.66 52.5-44.21 84-9.55 31.4-12.75 64.1-9.57 98 3.18 34 12.38 65.5 27.6 94.7 15.22 29.1 35.11 53.9 59.74 74.6 24.63 20.6 52.91 36.1 84.89 46.5 31.98 10.4 66.54 13.9 103.74 10.4 37.14-3.5 70.5-13.2 99.97-29.1 29.54-16 54.23-36.2 74.15-60.8 19.92-24.5 34.68-52.5 44.24-83.9 9.55-31.5 12.75-64.2 9.55-98.1-3.14-34-12.38-65.5-27.59-94.6"
			transform="matrix(.21 0 0 -.21 583.47 112.3) translate(-6477.85 -16047.45)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M7178.74 15756.9l-79.62 33.7 158.91 376-142.44 60.2 30.91 73.2 364.5-154-30.91-73.2-142.44 60.2-158.91-376.1"
			transform="matrix(.21 0 0 -.21 746.74 143.23) translate(-7305.06 -16028.45)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M8107.78 16193.5l-192.71-101.9 134.11-108.4zm-46.7-475.6l-72.32 58.5 36.49 126-184.2 148.8-116.1-61.7-70.11 56.7 488.39 253.8 63.48-51.3-145.63-530.8"
			transform="matrix(.21 0 0 -.21 834.74 235.6) translate(-7930.78 -16008.95)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M8518.94 15796.7l-52.38 74.4 351.86 247.5-93.76 133.3 68.47 48.1 239.82-341-68.4-48.2-93.75 133.3-351.86-247.4"
			transform="matrix(.2 0 0 -.2 957.23 310.78) translate(-8749.76 -16048.35)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M9684.11 15895.9l-96.51 288.3-131.05-43.9 85.56-255.5-80.81-27.1-85.56 255.5-136.08-45.5 97.7-291.9-80.81-27.1-127.42 380.7 509.55 170.6 126.24-377.1-80.81-27"
			transform="matrix(.19 0 0 -.19 1013.94 455.72) translate(-9447.03 -16024.35)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M10139.1 16215.2c0-46.9-38-84.9-84.9-84.9-46.9 0-84.89 38-84.89 84.9 0 46.9 37.99 84.8 84.89 84.8s84.9-37.9 84.9-84.8"
			transform="matrix(.18 0 0 -.18 1039.18 565.65) translate(-10054.21 -16215.15)"
			vectorEffect="non-scaling-stroke"></path>
		<path
			fill="#FFF"
			d="M4441.69 16215.2c0-46.9 38-84.9 84.86-84.9 46.87 0 84.86 38 84.86 84.9 0 46.9-37.99 84.8-84.86 84.8-46.86 0-84.86-37.9-84.86-84.8"
			transform="matrix(.18 0 0 -.18 32.93 565.65) translate(-4526.55 -16215.15)"
			vectorEffect="non-scaling-stroke"></path>
	</svg>
);

export const entity_mention_instructions = <div>
				<h2>Entity Mention</h2>
				<p>A span of text with a specific referent, such as a person, organization, or time. Things that can be referred to by a mention are called "entities."</p>
				<p>EntityMentions typically consist of a single noun phrase; however, other phrase types may also be marked as mentions. For example, in the phrase "French hotel," the adjective "French" might be marked as a mention for France.</p>
				<p><a href="https://hltcoe.github.io/concrete/schema/entities.html#Struct_EntityMention" target="_blank" rel="noopener noreferrer">concrete-entity-mention</a></p>
				
				<h3>Example Entity Mention Annotation</h3>
				<ol>
				  <li>Create an entity mention span<br />
					<img src={require('./tutorial/entity-mention-span-create.gif').default} alt="entity mention" style={{ width: '100%' }} />
				  </li>
				  <li>Assign an entity type to a span<br />
					<img src={require('./tutorial/entity-mention-typing.gif').default} alt="entity mention typing" style={{ width: '100%' }} />
				  </li>
				</ol>
			  </div>; 

export const situation_mention_instructions = <div>
<h2>Situation Mention</h2>
<p>Situations include events, relations, facts, sentiments, and beliefs. Each situation has a core type (such as EVENT or SENTIMENT), along with an optional subtype based on its core type (e.g., event_type=CONTACT_MEET), and a set of zero or more unordered arguments.</p>
<p><a href="https://hltcoe.github.io/concrete/schema/situations.html#Struct_SituationMention" target="_blank" rel="noopener noreferrer">concrete-situation-mention</a></p>

<h3>Example Situation Mention Annotation</h3>
<ol>
  <li>Create a situation mention span<br />
	<img src={require('./tutorial/situation-mention-span.gif').default} alt="situation mention" style={{ width: '100%' }} />
  </li>
  <li>Associate the situation mention with a situation frame<br />
	<img src={require('./tutorial/situation-mention-associate.gif').default} alt="situation mention associate" style={{ width: '100%' }} />
  </li>
  <li>Annotate roles of a situation part 1: switch to role-typing mode<br />
	<img src={require('./tutorial/situation-mention-role.gif').default} alt="situation mention role" style={{ width: '100%' }} />
  </li>
  <li>Annotate roles of a situation part 2: create a role span<br />
	<img src={require('./tutorial/situation-mention-role-create.gif').default} alt="situation mention role create" style={{ width: '100%' }} />
  </li>
  <li>Annotate roles of a situation part 3: assign a role to the role span<br />
	<img src={require('./tutorial/situation-mention-role-assign.gif').default} alt="situation mention role assign" style={{ width: '100%' }} />
  </li>
</ol>
</div>; 

export const situation_refernt_instructions = 
<div>
      <h2>Situation Coreference</h2>
      <p>An annotation to determine spans of texts that refer to the same situation.</p>
      
      <ol>
        <li>Create an entity span<br />
          <img src={require('./tutorial/situation-coref-entity-span.gif').default} alt="situation coref" style={{ width: '100%' }} />
        </li>
        <li>Assign the span to an entity<br />
          <img src={require('./tutorial/situation-coref-create-entity.gif').default} alt="situation coref create entity" style={{ width: '100%' }} />
        </li>
        <li>Assign a type to the entity<br />
          <img src={require('./tutorial/situation-coref-assign-entity-type.gif').default} alt="situation coref assign type" style={{ width: '100%' }} />
        </li>
        <li>Switch to situation coreference mode<br />
          <img src={require('./tutorial/situation-coref-switch-mode.gif').default} alt="situation coref switch mode" style={{ width: '100%' }} />
        </li>
        <li>Create a situation span<br />
          <img src={require('./tutorial/situation-coref-create-situation.gif').default} alt="situation coref create situation" style={{ width: '100%' }} />
        </li>
        <li>Assign the span to a situation<br />
          <img src={require('./tutorial/situation-coref-assign-situation.gif').default} alt="situation coref assign situation" style={{ width: '100%' }} />
        </li>
        <li>Assign a situation type<br />
          <img src={require('./tutorial/situation-coref-assign-situation-type.gif').default} alt="situation coref assign situation type" style={{ width: '100%' }} />
        </li>
        <li>Create a second situation span that is coreferent with the first situation span<br />
          <img src={require('./tutorial/situation-coref-create-situation-2.gif').default} alt="situation coref create situation 2" style={{ width: '100%' }} />
        </li>
        <li>Associate a relevant entity with the situation (modifying situation metadata)<br />
          - Ronald Reagan is shown as an option for `Assailant` because it is of the `sentient` type.<br />
          - Type constraints are enforced based on the FrameNet ontology in this example.<br />
          <img src={require('./tutorial/situation-coref-connect-entity.gif').default} alt="situation coref connect entity" style={{ width: '100%' }} />
        </li>
        <li>Automatic type locking after successful association<br />
          <img src={require('./tutorial/situation-coref-entity-changes.gif').default} alt="situation coref entity changes" style={{ width: '100%' }} />
        </li>
        <li>Type unlocks once the entity is no longer associated with the situation<br />
          <img src={require('./tutorial/situation-coref-entity-type-unlock.gif').default} alt="situation coref entity type unlocks" style={{ width: '100%' }} />
        </li>
      </ol>
    </div>; 
export const entity_refernt_instructions = <div>
<h2>Entity Coreference</h2>
<p>An annotation to determine spans of texts that refer to the same entity.</p>

<ol>
  <li>Create an entity span<br />
	<img src={require('./tutorial/entity-coref-span1.gif').default} alt="entity coref" style={{ width: '100%' }} />
  </li>
  <li>Create an entity<br />
	<img src={require('./tutorial/entity-coref-create-entity.gif').default} alt="entity coref create entity" style={{ width: '100%' }} />
  </li>
  <li>Assign a type to the entity<br />
	<img src={require('./tutorial/entity-coref-span-type.gif').default} alt="entity coref assign type" style={{ width: '100%' }} />
  </li>
  <li>Create a span that is coreferent with the first entity span<br />
	<img src={require('./tutorial/entity-coref-create-coref.gif').default} alt="entity coref create coref" style={{ width: '100%' }} />
  </li>
  <li>Add the new span to its coreferent entity<br />
	<img src={require('./tutorial/entity-coref-add-entity-mention-to-entity.gif').default} alt="entity coref assign coref" style={{ width: '100%' }} />
  </li>
</ol>
</div>; 
export const basic_actions_instructions = 
<div>
<h2>Basic Actions</h2>
<ul>
  <li>Create a span<br />
	<img src={require('./tutorial/create-span.gif').default} alt="Create a span" style={{ width: '100%' }} />
  </li>
  <li>Extend a span<br />
	<img src={require('./tutorial/extend-span.gif').default} alt="Extend a span" style={{ width: '100%' }} />
  </li>
  <li>Delete a span<br />
	<img src={require('./tutorial/delete-span.gif').default} alt="Delete a span" style={{ width: '100%' }} />
  </li>
  <li>Create a nested span<br />
	<img src={require('./tutorial/create-nested-span.gif').default} alt="Create a nested span" style={{ width: '100%' }} />
  </li>
  <li>Searching<br />
	<img src={require('./tutorial/ontology-search.gif').default} alt="Ontology Search" style={{ width: '100%' }} />
  </li>
</ul>
</div>; 

export const entity_mention_annotation_scheme = require("./annotation-scheme/sample-entity-mention-annotation-scheme_5.json");
export const situation_mention_annotation_scheme = require("./annotation-scheme/sample-situation-mention-annotation-scheme_5.json");
export const entity_referent_annotation_scheme = require("./annotation-scheme/sample-entity-referent-annotation-scheme_5.json");
export const situation_referent_annotation_scheme = require("./annotation-scheme/sample-situation-referent-annotation-scheme_5.json");
export const entity_mention_data = require("./test_data/APW_ENG_20090611_0697_combined.concrete_5_entities.json")
export const situation_mention_data = require("./test_data/APW_ENG_20090611_0697_combined.concrete_5_situations.json")